"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenuContent = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _navigation = require("../../../context/navigation");
var _BeautyAndTrends = require("../BeautyAndTrends");
var _BestOffers = require("../BestOffers");
var _Catalogues = require("../Catalogues/Catalogues");
var _CategoryContent = require("../CategoryContent/CategoryContent");
var _FindYourProduct = require("../FindYourProduct/FindYourProduct");
var _constants = require("../constants");
var _styles = require("../styles");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
const BurgerMenuContent = ({
  contentRootRef,
  link
}) => {
  const {
    activeLink
  } = (0, _navigation.useActiveLink)();
  const {
    linkType,
    id
  } = activeLink ?? {};
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const navigation = (0, _utils.useGetNavigationType)({
    activeLinkType: linkType ?? 'None',
    link
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuContentRoot, {
    ref: contentRootRef,
    "data-testid": getTestId(_constants.BURGER_MENU_CONTENT_ROOT),
    children: navigation.isCatalogue || linkType === undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Catalogues.Catalogues, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [navigation.isCategory && id ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CategoryContent.CategoryContent, {
        "data-testid": getTestId(_constants.CATEGORY_WRAPPER)
      }) : null, navigation.isInspiration ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FindYourProduct.FindYourProduct, {}) : null, navigation.isBeautyAndTrends ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_BeautyAndTrends.BeautyAndTrends, {
        content: activeLink?.children
      }) : null, navigation.isBestOffers ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_BestOffers.BestOffers, {
        content: activeLink?.children
      }) : null]
    })
  });
};
exports.BurgerMenuContent = BurgerMenuContent;
